import {useEffect} from 'react';
import {toast} from 'sonner';
import {useQuery} from '@tanstack/react-query';
import {
  LocalStorage,
  FastAPIServiceError,
  Guidebook,
  PaginatedV2,
  QUERY_CACHE_KEYS,
  getFastAPIErrorMessage,
} from '@chekin/core';
import {API, LS_I18NEXT_LNG_KEY} from '@chekin/api';

type Props = {
  reservationId: string;
};

function useFetchGuidebooks({reservationId}: Props) {
  const language = LocalStorage.get<string>(LS_I18NEXT_LNG_KEY);

  const query = useQuery<PaginatedV2<Guidebook>, FastAPIServiceError>({
    queryKey: [QUERY_CACHE_KEYS.guidebooks, reservationId, language],
    queryFn: () => API.guidebooks.getGuidebooks(reservationId),
    enabled: Boolean(reservationId),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (query.error) {
      toast.error(getFastAPIErrorMessage(query.error));
    }
  }, [query.error]);

  return query;
}

export {useFetchGuidebooks};
